<template>
  <a-modal
    width="1200px"
    :visible="visible"
    title="新建客户运营目标"
    :maskClosable="false"
    :confirmLoading="loading"
    @cancel="handleCancel"
    @ok="handleOk"
    okText="保存"
  >
    <div style="display: flex; justify-content: space-between">
      <a-form-item label="门店">
        <a-select v-model:value="shop_id" placeholder="请选择门店" style="width: 150px" allowClear>
          <a-select-option :value="item.id" v-for="item in sourceShopDatasource" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-button style="float: right" type="primary" @click="() => handleAddItem()">增加</a-button>
    </div>
    <a-table
      :scroll="{ y: 400 }"
      :columns="columns"
      row-key="id"
      :data-source="datasource"
      :pagination="false"
    >
      <template #index="{ index }">
        {{ index + 1 }}
      </template>
      <template #date="{ record }">
        <a-date-picker
          v-model:value="record.date"
          picker="month"
          placeholder="请选择月份"
          :format="'YYYY-MM'"
          :value-format="'YYYY-MM-01'"
          @change="v => changeDate(v, record)"
        />
      </template>
      <template #staff_id="{ record }">
        <a-select
          v-model:value="record.staff_id"
          placeholder="请选择员工"
          @change="v => changeStaff(v, record)"
        >
          <a-select-option :value="item.id" v-for="item in sourceStaffDatasource">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template
        v-for="col in [
          'yye_target_amount',
          'kl_target_count',
          'rt_target_count',
          'xhy_target_count',
        ]"
        #[col]="{ record }"
        :key="col"
      >
        <a-input-number v-model:value="record[col]" style="margin: -5px 0" min="0" />
      </template>
      <template #action="{ record, index }">
        <a-button type="danger" @click="() => handleDeleteItem(record, index)">删除</a-button>
      </template>
    </a-table>
  </a-modal>
</template>

<script lang="ts">
import { createVNode, defineComponent, h, onMounted, ref, watch } from 'vue';
import { message, Modal, notification } from 'ant-design-vue';
import { reactive } from 'vue';
import { query_staff_list, query_shop_list } from '@/api/mjstore-model';
import {
  bulk_create_staff_operation_target,
  query_staff_operation_target_list,
} from '@/api/mjstat-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { event_obj } from '@/components/page-model/mjstore/mjstore-orderrecord-config';
import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'Staffoperationtargetmodel',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    obj: {
      type: Object,
      required: true,
    },
  },
  emits: ['ok', 'cancel'],
  setup(props: any, { emit }: any) {
    onMounted(() => {
      init();
    });
    const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
    const loading = ref(false);
    const shop_id = ref(null);
    const sourceShopDatasource: Array<any> = reactive([]);
    const sourceStaffDatasource: Array<any> = reactive([]);
    const datasource: Array<any> = reactive([]);
    const columns: Array<any> = reactive([
      {
        title: '序号',
        width: 60,
        dataIndex: 'index',
        checked: true,
        slots: { customRender: 'index' },
      },
      {
        title: '月份',
        width: 150,
        dataIndex: 'date',
        checked: true,
        slots: { customRender: 'date' },
      },
      {
        title: '员工',
        width: 150,
        dataIndex: 'staff_id',
        checked: true,
        slots: { customRender: 'staff_id' },
      },
      {
        title: '营业额目标',
        width: 150,
        dataIndex: 'yye_target_amount',
        checked: true,
        slots: { customRender: 'yye_target_amount' },
      },
      {
        title: '客流目标',
        width: 150,
        dataIndex: 'kl_target_count',
        checked: true,
        slots: { customRender: 'kl_target_count' },
      },
      {
        title: '人头目标',
        width: 150,
        dataIndex: 'rt_target_count',
        checked: true,
        slots: { customRender: 'rt_target_count' },
      },
      {
        title: '新会员目标',
        width: 150,
        dataIndex: 'xhy_target_count',
        checked: true,
        slots: { customRender: 'xhy_target_count' },
      },
      {
        title: '操作',
        width: 150,
        dataIndex: 'action',
        checked: true,
        slots: { customRender: 'action' },
      },
    ]);
    const init = () => {
      getShopData();
      getStaffData('', true);
    };
    const getShopData = () => {
      query_shop_list({
        org_id: current_org.id,
        is_active: true,
        page_index: 1,
        pageSize: 2000,
      }).then((res: any) => {
        sourceShopDatasource.length = 0;
        res.data.forEach((item: any) => {
          sourceShopDatasource.push(item);
        });
      });
    };
    const getStaffData = (temp_shop_id: any, is_source: boolean) => {
      let params: any = {
        org_id: current_org.id,
        is_active: true,
        page_index: 1,
        pageSize: 2000,
        is_adviser: true,
      };
      if (temp_shop_id) {
        params.shop_id = temp_shop_id;
      }
      query_staff_list(params).then((res: any) => {
        if (is_source) {
          sourceStaffDatasource.length = 0;
          res.data.forEach((item: any) => {
            sourceStaffDatasource.push(item);
          });
        }
        datasource.length = 0;
        const date = moment().format('YYYY-MM-01');
        res.data.forEach((item: any) => {
          datasource.push({
            date,
            staff_id: item.id,
            staff__name: item.name,
            xhy_target_count: null,
            rt_target_count: null,
            kl_target_count: null,
            yye_target_amount: null,
          });
        });

        const staff_ids = datasource.map(item => {
          if (!item.staff_id) {
            return item.staff_id;
          }
        });
        queryStaffOperationTargetList(date, staff_ids);
      });
    };

    const queryStaffOperationTargetList = (date: any, shop_ids: any) => {
      query_staff_operation_target_list({
        org_id: current_org.id,
        staff_ids: shop_ids,
        date: date,
      }).then((res: any) => {
        res.data.forEach((item: any) => {
          datasource.forEach(obj => {
            if (item.shop_id == obj.shop_id && item.date == obj.date) {
              obj.yye_target_amount = item.yye_target_amount;
              obj.kl_target_count = item.kl_target_count;
              obj.rt_target_count = item.rt_target_count;
              obj.xhy_target_count = item.xhy_target_count;
            }
          });
        });
      });
    };
    const changeDate = (date: any, record: any) => {
      record.yye_target_amount = null;
      record.kl_target_count = null;
      record.rt_target_count = null;
      record.xhy_target_count = null;
      queryStaffOperationTargetList(date, record.shop_id);
    };
    const changeShop = (shop_ids: any, record: any) => {
      record.yye_target_amount = null;
      record.kl_target_count = null;
      record.rt_target_count = null;
      record.xhy_target_count = null;
      queryStaffOperationTargetList(record.date, shop_ids);
    };
    const handleDeleteItem = (record: any, index: number) => {
      datasource.splice(index, 1);
    };
    const handleAddItem = () => {
      datasource.push({
        date: moment().format('YYYY-MM-01'),
        staff_id: null,
        staff__name: null,
        yye_target_amount: null,
        kl_target_count: null,
        rt_target_count: null,
        xhy_target_count: null,
      });
      setTimeout(() => {
        const el = (document as any).querySelector('div.ant-table-body');
        el.scrollTop = el.scrollHeight;
      }, 100);
    };
    const handleCancel = () => {
      emit('cancel');
    };
    const handleOk = () => {
      let is_ok = true;
      let is_confirm = false;
      let msg = '';
      let msg_list: any = [];
      let list: any = [];
      datasource.some((item, i) => {
        if (!item.date) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}数据缺少月份。`);
        } else if (!item.staff_id) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}数据缺少【员工】。`);
        } else if (!item.yye_target_amount) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}数据缺少【营业额目标】。`);
        } else if (!item.kl_target_count) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}数据缺少【客流目标】。`);
        } else if (!item.rt_target_count) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}数据缺少【人头目标】。`);
        } else if (!item.xhy_target_count) {
          is_confirm = true;
          msg_list.push(`请确认数据，第${i + 1}数据缺少【新会员目标】。`);
        } else {
          list.push(item);
        }
        datasource.some((obj, j) => {
          if (i != j && item.staff_id == obj.staff_id && item.date == obj.date) {
            is_ok = false;
            msg = `请确认数据，第${i + 1}条数据与第${j + 1}条【月份:${item.date},员工${
              item.staff__name
            }】数据重复。`;
          }
        });
        if (!is_ok) {
          return true;
        }
      });
      if (!is_ok) {
        message.warning(msg);
        return;
      }
      if (list.length == 0) {
        message.warning('提交的数据不能为空');
        return;
      }
      if (is_confirm) {
        Modal.confirm({
          title: `${msg}是否忽略缺填数据，仍然提交？`,
          content: h('pre', `${msg_list.join('\n')}`),
          icon: createVNode(ExclamationCircleOutlined),
          onOk() {
            submit_fun(list);
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onCancel() {},
        });
      } else {
        submit_fun(list);
      }
    };
    const submit_fun = (list: any) => {
      bulk_create_staff_operation_target({
        org_id: current_org.id,
        staff_operation_target_json: JSON.stringify(list),
      }).then(
        (res: any) => {
          notification.success({
            message: '成功',
            description: '创建成功',
          });
          emit('ok');
          event_obj.emit('refresh');
          loading.value = false;
        },
        res => {
          message.warning();
        },
      );
    };
    watch(
      () => shop_id.value,
      () => {
        getStaffData(shop_id.value, false);
      },
    );
    return {
      loading,
      columns,
      shop_id,
      sourceShopDatasource,
      sourceStaffDatasource,
      datasource,
      handleDeleteItem,
      handleCancel,
      handleAddItem,
      handleOk,
      changeShop,
      changeDate,
    };
  },
});
</script>
